import React from 'react';

import {
  TextField,
  Autocomplete,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Slider,
} from '@mui/material';
import { DateTimePicker, TimePicker, DatePicker } from '@mui/x-date-pickers';
import CircularProgress from '@mui/material/CircularProgress';

function CustomInput({
  type,
  fullWidth,
  keys,
  size,
  label,
  error,
  value,
  options,
  getOptionLabel,
  readOnly,
  sx = {},
  items,
  style,
  minDateTime,
  maxDateTime,
  onChange,
  errorText,
  loading,
  defaultValue,
  flagIcon,
  inputType,
  rows,
}) {
  return (
    <div className="w-full">
      {type === 'select' ? (
        <FormControl fullWidth={fullWidth} sx={sx}>
          <InputLabel id={keys} size={size || 'medium'}>
            {label}
          </InputLabel>
          <Select
            size={size || 'medium'}
            defaultValue={defaultValue}
            fullWidth={fullWidth}
            sx={sx ? sx : { minWidth: 248 }}
            id={keys}
            value={value}
            onChange={(e, n = '') => onChange(n, e.target.value)}
            label={label}
            style={style}
          >
            {items?.map((item) => (
              <MenuItem value={item.value} key={Math.random()}>
                <div className="flex w-full h-full">
                  <div className="flex justify-center items-center">
                    {flagIcon && (
                      <img
                        srcSet={`https://flagcdn.com/w40/${item.value.toLowerCase()}.png 2x`}
                        src={`https://flagcdn.com/w20/${item.value.toLowerCase()}.png`}
                        alt={item.value}
                        width={20}
                        style={{ marginRight: 10 }}
                      />
                    )}
                  </div>
                  <div>{item.text}</div>
                </div>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : type === 'date' ? (
        <DatePicker
          style={style}
          label={label}
          ampm="false"
          size={'small'}
          value={value !== null ? new Date(value) : value}
          onChange={(e, n = '') => onChange(n, e)}
          slotProps={{ textField: { readOnly: true } }}
          fullWidth={fullWidth}
          mindatetime={minDateTime ?? minDateTime}
          maxatetime={maxDateTime ?? maxDateTime}
        />
      ) : type === 'time' ? (
        <TimePicker
          style={style}
          label={label}
          ampm={false}
          value={value}
          onChange={(e, n = '') => onChange(n, e)}
          renderInput={(params) => (
            <TextField sx={sx} fullWidth size={size || 'medium'} {...params} />
          )}
          size={size}
          minDateTime={minDateTime ?? minDateTime}
          maxDateTime={maxDateTime ?? maxDateTime}
        />
      ) : type === 'datetimeOffset' ? (
        <DateTimePicker
          label={label}
          ampm={false}
          value={value}
          onChange={(e, n = '') => onChange(n, e)}
          minDateTime={minDateTime ?? minDateTime}
          maxDateTime={maxDateTime ?? maxDateTime}
          disableIgnoringDatePartForTimeValidation
          inputFormat="dd.MM.yyyy hh:mm"
          placeholder="dd.MM.yyyy hh:mm"
          mask="__.__.____ __:__"
        />
      ) : type === 'auto' ? (
        <Autocomplete
          sx={sx}
          disablePortal
          options={options}
          value={value}
          fullWidth
          loading={loading}
          getOptionLabel={getOptionLabel}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          renderInput={(params) => {
            return readOnly ? (
              <TextField
                {...params}
                InputProps={{
                  readOnly: true,
                }}
                label={label}
              />
            ) : (
              <TextField
                {...params}
                fullWidth
                size={size || 'medium'}
                label={label}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  ),
                }}
              />
            );
          }}
          onChange={onChange}
        />
      ) : (
        <TextField
          sx={sx}
          type={inputType}
          size={size}
          label={label}
          multiline={type === 'textarea'}
          rows={type === 'textarea' ? rows : 1}
          variant="outlined"
          fullWidth={fullWidth}
          value={value}
          error={error}
          helperText={errorText}
          InputProps={{
            readOnly: readOnly,
          }}
          onChange={(e, n = '') => onChange(n, e.target.value)}
        />
      )}
    </div>
  );
}

export default CustomInput;
